import Publishing from 'app/developer-v3/pages/publishing';

export default {
  routes: {
    '.': Publishing,
  },
};
